import {PluginSettings} from '@wordpress/plugins';
import Pages from './pages/Edit';
import Categories from './categories/Edit';
import {addAction, addFilter} from '@wordpress/hooks';
import {Initialize, initializeAccordions} from './Accordion';
import {FunctionComponent} from 'react';

export const name = 'advanced-sidebar-menu-pro-blocks';

export const settings: PluginSettings = {
	icon: 'welcome-widgets-menus',
	render: () => {
		// Remove the info panel from the basic version.
		addFilter( 'advanced-sidebar-menu.blocks.info-panel', 'advanced-sidebar-menu-pro', () => () => null );

		// Remove the exclude field from the basic version.
		addFilter( 'advanced-sidebar-menu.blocks.exclude-field', 'advanced-sidebar-menu-pro', () => () => null );

		// Initialize the accordions on preview change.
		addAction<Initialize>( 'advanced-sidebar-menu.blocks.preview.loading-finished', 'advanced-sidebar-menu', initializeAccordions );

		// Default functionality using `PluginArea` to load our `Fills`.
		// @ts-ignore
		if ( 'undefined' === typeof wp.customize ) {
			return ( <>
				<Categories />
				<Pages />
			</> );
		}

		// Side load the Fills into the Customizer.
		addFilter<FunctionComponent<{ clientId: string }>>( 'advanced-sidebar-menu.blocks.side-load', 'advanced-sidebar-menu-pro', SideLoad => props => (
			<SideLoad {...props}>
				<Categories />
				<Pages />
			</SideLoad> )
		);

		return null;
	},
};
